export const Select = (props) => {
  const { className, label, input, children, disabled, onlyInput = false } = props;

  return (
    <div className={className}>
      {!onlyInput && <label>{label}</label>}
      <select {...input} disabled={disabled}>
        {children}
      </select>
    </div>
  );
};
